import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=74287f34&scoped=true&"
var script = {}
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=74287f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74287f34",
  null
  
)

export default component.exports